import { ReactNode } from "react";

import { Callout } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { PrimaryButton } from "@/components/pieces/button/PrimaryButton";

export function SuccessDialogContent({
  children,
  onClose,
}: {
  children: ReactNode;
  onClose: () => void;
}) {
  return (
    <>
      <Callout intent="success">{children}</Callout>
      <Box mt={20}>
        <PrimaryButton onClick={onClose}>Close</PrimaryButton>
      </Box>
    </>
  );
}
